require('./widgets/ReactApp/ReactDesktop.jsx');
